import * as actionTypes from "./actionTypes";
import api from "./api";
import { showError } from "actions/actionCreators/snackbarActions";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { checkAssetHierarchyTriggers, loadAssetHierarchyLevels } from "../hierarchy/actionCreators";
import * as eventTypes from "./eventTypes";

export function checkHierarchyTriggers(hierarchy) {
  return async dispatch => {
    dispatch(checkAssetHierarchyTriggers(hierarchy));

    const priceTriggers = hierarchy.filter(z => z.triggers.price);
    priceTriggers
      .filter(z => z.id)
      .forEach(z => {
        dispatch(loadAssetBasePrice(z.id));
      });

    const equipmentsTriggers = hierarchy.filter(z => z.triggers.equipments);
    equipmentsTriggers
      .filter(z => z.id)
      .forEach(z => {
        dispatch(loadAssetEquipments(z.id));
      });
  };
}

const levelsOptions = { result: { dispatch: false, return: true } };
export function loadHierarchyLevels(assetTypeId, editRight) {
  return async dispatch => {
    const levels = await dispatch(loadAssetHierarchyLevels(assetTypeId, editRight, levelsOptions));
    return levels;
  };
}

export function loadAssetBasePrice(assetHierarchyId) {
  return async dispatch => {
    try {
      const result = await dispatch(sendHttpRequest(api.getAssetBasePrice(assetHierarchyId)));
      dispatch({ type: actionTypes.LOAD_ASSET_BASE_PRICE_SUCCESS, payload: { basePrice: result.basePrice } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadAssetEquipments(assetHierarchyId) {
  return async (dispatch, getState) => {
    const equipments = getState().asset.configurator.equipments[assetHierarchyId];
    if (equipments) return;

    dispatch({ type: actionTypes.LOAD_ASSET_EQUIPMENTS_STARTED, id: assetHierarchyId });
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(api.getAssetEquipments(assetHierarchyId)),
        "loadAssetEquipmentsCommand",
        [eventTypes.ASSET_EQUIPMENTS_LOADED]
      );

      if (event.ok) {
        dispatch({
          type: actionTypes.LOAD_ASSET_EQUIPMENTS_SUCCESS,
          payload: { equipments: event.eventBody.equipments },
          id: assetHierarchyId
        });
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function invalidateConfiguratorData() {
  return async dispatch => {
    dispatch({ type: actionTypes.INVALIDATE_CONFIGURATOR_DATA });
  };
}
